var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-project-name text-truncate",class:{ 'text-left pr-2 pl-4': !_vm.largeDisplay },staticStyle:{"flex":"1 1 50%"}},[_vm._v(" "+_vm._s(_vm.$t('application.project.name'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }